export enum CupomDescontoStatusEnum {
    ATIVO = 'ATIVO',
    DESATIVADO = 'DESATIVADO'
}
